interface ScrollCellInlineInput {
    viewport: HTMLElement;
    cell: HTMLElement;
    /** Width covered by start-pinned columns. */
    startInset: number;
    /** Width covered by end-pinned columns. */
    endInset: number;
}

/**
 * Scrolls the viewport horizontally so a cell clears the pinned columns.
 * Pinned cells never need it. Vertical scrolling belongs to the virtualizer.
 */
export const scrollCellIntoViewInline = ({
    viewport,
    cell,
    startInset,
    endInset,
}: ScrollCellInlineInput) => {
    if (cell.dataset.pin) {
        return;
    }
    const viewportRect = viewport.getBoundingClientRect();
    const cellRect = cell.getBoundingClientRect();
    const visibleStart = viewportRect.left + startInset;
    const visibleEnd = viewportRect.left + viewport.clientWidth - endInset;
    if (cellRect.left < visibleStart) {
        viewport.scrollLeft -= visibleStart - cellRect.left;
    } else if (cellRect.right > visibleEnd) {
        viewport.scrollLeft += Math.min(
            cellRect.right - visibleEnd,
            cellRect.left - visibleStart,
        );
    }
};
